import MasterDataMutationTypes from './MasterDataMutationTypes';

const MasterDataMutations = {
  [MasterDataMutationTypes.UPDATE_LOADING_STATE](state, loadingState) {
    state.isLoading = loadingState;
  },
  [MasterDataMutationTypes.UPDATE_MASTER_DATA](state, masterData) {
    state.masterData = masterData;
  },
  [MasterDataMutationTypes.UPDATE_FILES](state, files) {
    state.files = files;
  },
};

export default MasterDataMutations;
